<!-- form fields which are grouped in a fieldset -->
{% if (ctx.component.type === 'radio' || ctx.component.type === 'selectboxes') { %}
  <div class="utrecht-form-fieldset utrecht-form-fieldset--openforms">
    <fieldset
      class="utrecht-form-fieldset__fieldset utrecht-form-fieldset--html-fieldset"
      {% if (ctx.component.type === 'radio') { %}role="radiogroup"{% } %}
      {% if (ctx.component.description) { %}aria-describedby="{{ctx.id}}-description"{% } %}
    >

      <legend class="utrecht-form-fieldset__legend utrecht-form-fieldset__legend--html-legend utrecht-form-field__label">
        <span class="utrecht-form-label utrecht-form-label--openforms{% if (ctx.component.validate.required && ctx.requiredFieldsWithAsterisk){%} utrecht-form-label--openforms-required{%}%}">
          {{ ctx.t(ctx.component.label, { _userInput: true }) }}
          {% if (!ctx.component.validate.required && !ctx.requiredFieldsWithAsterisk) { %}
            {{ ctx.t('(not required)') }}
          {% } %}
          {% if (ctx.component.tooltip) { %}
            <i ref="tooltip" class="openforms-tooltip-icon {{ctx.iconClass('question-sign')}}"data-tooltip="{{ ctx.tooltip }}"></i>
          {% } %}
        </span>
      </legend>

      {{ctx.element}}

      {% if (ctx.component.description) { %}
        <div
          class="utrecht-form-field-description utrecht-form-field-description--openforms-helptext"
          id="{{ctx.id}}-description"
        >
          {{ctx.component.description}}
        </div>
      {% } %}

      <div
        ref="messageContainer"
        class="utrecht-form-field-description utrecht-form-field-description--invalid utrecht-form-field-description--openforms-errors"
        role="alert"
        id="{{ctx.instance.id}}-{{ctx.component.key}}-error-message"></div>

    </fieldset>
  </div>

<!-- layout/container fields -->
{% } else if (ctx.component.type === 'form') { %}

  {{ctx.element}}

<!-- leaf nodes -->
{% } else { %}
  <div class="utrecht-form-field
              utrecht-form-field--{{ctx.component.type}}
              utrecht-form-field--openforms
              {% if (ctx.component?.openForms?.requireVerification) { %}utrecht-form-field--has-button{% } %}
  ">
    {% if (!ctx.label.hidden && ctx.label.labelPosition !== 'bottom') { %}
      {{ ctx.labelMarkup }}
    {% } %}

    {% if (ctx.label.hidden && ctx.label.className && ctx.component.validate.required && ctx.requiredFieldsWithAsterisk) { %}
      <label class="utrecht-form-label utrecht-form-label--openforms utrecht-form-label--openforms-required {{ctx.label.className}}"></label>
    {% } %}

    {{ctx.element}}

    {% if (!ctx.label.hidden && ctx.label.labelPosition === 'bottom') { %}
      {{ ctx.labelMarkup }}
    {% } %}

    {% if (ctx.component.description) { %}
      <div class="utrecht-form-field-description utrecht-form-field-description--openforms-helptext">{{ctx.component.description}}</div>
    {% } %}

    <div
      ref="messageContainer"
      class="utrecht-form-field-description utrecht-form-field-description--invalid utrecht-form-field-description--openforms-errors"
      role="alert"
      id="{{ctx.instance.id}}-{{ctx.component.key}}-error-message"></div>
  </div>
{% } %}
